var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 41,
    fill: "#FF6DB2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7312 40.8771C55.7307 48.3994 50.1057 54.7331 42.6362 55.6221V45.5721H45.2762C45.6463 45.5741 45.9577 45.2952 45.9962 44.9271L46.2812 42.7521C46.301 42.5456 46.236 42.3399 46.1012 42.1821C45.9632 42.019 45.7599 41.9256 45.5462 41.9271H42.6362V39.3771C42.6362 38.5487 43.3078 37.8771 44.1362 37.8771H45.6362C45.8297 37.8812 46.0168 37.8071 46.155 37.6716C46.2933 37.5362 46.3712 37.3507 46.3712 37.1571V34.7421C46.3664 34.3664 46.0843 34.0522 45.7112 34.0071C45.7112 34.0071 44.6312 33.9171 43.3412 33.9171C40.1312 33.9171 38.3612 35.8221 38.3612 39.2871V41.9271H35.3612C34.9553 41.9271 34.6262 42.2562 34.6262 42.6621V44.8371C34.6262 45.2431 34.9553 45.5721 35.3612 45.5721H38.2712V55.5021C30.5184 54.1276 25.1822 46.9462 26.1033 39.1266C27.0243 31.3069 33.883 25.5619 41.743 26.0263C49.603 26.4907 55.7374 33.0034 55.7312 40.8771Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.847acb4736a1870ad3ac8d05b1ac3fc1.svg";
export { ForwardRef as ReactComponent };